export default __webpack_public_path__ + "static/media/plan_question_theory.e0e2613d.png";